import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { GdRecommendationStatus } from '../../../typings/graphql-grid';
import { Kpi, RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { RecommendationCard, RecommendationCardView } from '../../RecommendationCard/RecommendationCard';
import { RecommendationKpiInfo, RecommendationKpiType } from '../../RecommendationKpiInfo/RecommendationKpiInfo';
import { Shape2Icon } from '../../Shape2/Shape2';

import * as keyset from './SwitchOnAutoTargetingRecommendationCardGridPopup.i18n';

const i18n = i18nFactory(keyset);

export interface SwitchOnAutotargetingRecommendationCardGridPopupProps {
    kpi: Kpi;
    character: RecommendationCharacter;
    icon: Shape2Icon;
    status: GdRecommendationStatus;
    isApplicable: boolean;
    onAcceptClick: () => void;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export class SwitchOnAutotargetingRecommendationCardGridPopup extends React.Component<
    SwitchOnAutotargetingRecommendationCardGridPopupProps
> {
    render() {
        const {
            status,
            isApplicable,
            character,
            icon,
            kpi: { periodValue, clicks, cost, sign, currency },
            onShow
        } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.switchOnAutotargeting}
                view={RecommendationCardView.recommendationsPopup}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                buttons={this.getButtons()}
                isInProgress={status === GdRecommendationStatus.IN_PROGRESS}
                progressHint={this.getProgressHintText()}
                isApplicable={isApplicable}
                onShow={onShow}
            >
                <RecommendationKpiInfo
                    currency={currency}
                    periodValue={periodValue}
                    kpi={{
                        type: RecommendationKpiType.clicks,
                        value: clicks
                    }}
                    cost={cost}
                    sign={sign}
                />
            </RecommendationCard>
        );
    }

    private getTitle = (): string => {
        return i18n('simple-title');
    };

    private getTitleHint = (): string => {
        return i18n('title-hint');
    };

    private getButtons = () => {
        const props = this.props;

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                disabled={!props.isApplicable}
                onClick={props.onAcceptClick}
                text={i18n('accept-button')}
            />
        ];
    };

    private getProgressHintText = (): string => {
        return i18n('simple-progress-hint');
    };
}
